(() => {
  const initGRLWorld = (section) => {
    if (!section || section.dataset.grlWorldReady === 'true') return;

    const rail = section.querySelector('[data-world-rail]');
    const cards = [...section.querySelectorAll('[data-world-card]')];
    const modal = section.querySelector('[data-world-modal]');
    const modalContent = section.querySelector(
      '[data-world-modal-content]'
    );
    const prevRail = section.querySelector('[data-world-rail-prev]');
    const nextRail = section.querySelector('[data-world-rail-next]');
    const prevStory = section.querySelector('[data-world-prev]');
    const nextStory = section.querySelector('[data-world-next]');
    const closeButtons = [
      ...section.querySelectorAll('[data-world-close]')
    ];

    if (!rail || !modal || !modalContent || !cards.length) return;

    let activeIndex = 0;
    let lastTrigger = null;

    const getStep = () => {
      const firstCard = cards[0];

      if (!firstCard) {
        return rail.clientWidth * 0.8;
      }

      const styles = getComputedStyle(rail);
      const gap = parseFloat(
        styles.columnGap || styles.gap || 0
      );

      return firstCard.getBoundingClientRect().width + gap;
    };

    const scrollRail = (direction) => {
      rail.scrollBy({
        left: getStep() * direction,
        behavior: 'smooth'
      });
    };

    const syncNav = () => {
      if (prevStory) {
        prevStory.disabled = activeIndex <= 0;
      }

      if (nextStory) {
        nextStory.disabled =
          activeIndex >= cards.length - 1;
      }
    };

    const renderStory = (index) => {
      const card = cards[index];

      if (!card) return;

      const blockId =
        card.querySelector('[data-world-open]')
          ?.dataset.worldOpen ||
        card.querySelector('[data-world-product-open]')
          ?.dataset.worldProductOpen;

      const template = blockId
        ? card.querySelector(
            `template[data-world-template="${CSS.escape(
              blockId
            )}"]`
          )
        : null;

      if (!template) return;

      activeIndex = index;

      modalContent.innerHTML = '';

      modalContent.appendChild(
        template.content.cloneNode(true)
      );

      syncNav();

      const video = modalContent.querySelector('video');

      if (video) {
        video.muted = true;

        video.play().catch(() => {});
      }
    };

    const openModal = (index, trigger) => {
      lastTrigger =
        trigger || document.activeElement;

      renderStory(index);

      modal.hidden = false;

      modal.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'grl-world-modal-open'
      );

      requestAnimationFrame(() => {
        modal
          .querySelector(
            '.grl-world-modal__close'
          )
          ?.focus();
      });
    };

    const closeModal = () => {
      modalContent
        .querySelectorAll('video')
        .forEach((video) => {
          video.pause();
        });

      modal.hidden = true;

      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      modalContent.innerHTML = '';

      document.body.classList.remove(
        'grl-world-modal-open'
      );

      if (
        lastTrigger &&
        typeof lastTrigger.focus === 'function'
      ) {
        lastTrigger.focus();
      }
    };

    cards.forEach((card, index) => {
      const mediaTrigger =
        card.querySelector(
          '[data-world-open]'
        );

      mediaTrigger?.addEventListener(
        'click',
        () => {
          openModal(
            index,
            mediaTrigger
          );
        }
      );

      card
        .querySelectorAll(
          '[data-world-product-open]'
        )
        .forEach(
          (productTrigger) => {
            productTrigger.addEventListener(
              'click',
              (event) => {
                event.preventDefault();

                event.stopPropagation();

                openModal(
                  index,
                  productTrigger
                );
              }
            );
          }
        );
    });

    prevRail?.addEventListener(
      'click',
      () => {
        scrollRail(-1);
      }
    );

    nextRail?.addEventListener(
      'click',
      () => {
        scrollRail(1);
      }
    );

    prevStory?.addEventListener(
      'click',
      () => {
        if (activeIndex > 0) {
          renderStory(
            activeIndex - 1
          );
        }
      }
    );

    nextStory?.addEventListener(
      'click',
      () => {
        if (
          activeIndex <
          cards.length - 1
        ) {
          renderStory(
            activeIndex + 1
          );
        }
      }
    );

    closeButtons.forEach(
      (button) => {
        button.addEventListener(
          'click',
          closeModal
        );
      }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (modal.hidden) return;

        if (event.key === 'Escape') {
          closeModal();
          return;
        }

        if (
          event.key ===
            'ArrowLeft' &&
          activeIndex > 0
        ) {
          renderStory(
            activeIndex - 1
          );
        }

        if (
          event.key ===
            'ArrowRight' &&
          activeIndex <
            cards.length - 1
        ) {
          renderStory(
            activeIndex + 1
          );
        }

        if (event.key === 'Tab') {
          const focusable = [
            ...modal.querySelectorAll(
              'a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])'
            )
          ].filter(
            (el) =>
              !el.hasAttribute(
                'hidden'
              ) &&
              el.offsetParent !==
                null
          );

          if (!focusable.length) {
            return;
          }

          const first =
            focusable[0];

          const last =
            focusable[
              focusable.length - 1
            ];

          if (
            event.shiftKey &&
            document.activeElement ===
              first
          ) {
            event.preventDefault();

            last.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement ===
              last
          ) {
            event.preventDefault();

            first.focus();
          }
        }
      }
    );

    section.dataset.grlWorldReady =
      'true';
  };

  const initAll = (
    root = document
  ) => {
    root
      .querySelectorAll(
        '[data-grl-world]'
      )
      .forEach(
        initGRLWorld
      );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll();
      }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(
        event.target
      );
    }
  );
})();